// Centralised data-testid registry for the Srikanth Studio portfolio.
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "site-header",
  logo: "site-header-logo",
  linkHome: "nav-link-home",
  linkWork: "nav-link-work",
  linkAbout: "nav-link-about",
  linkContact: "nav-link-contact",
  ctaTalk: "nav-cta-lets-talk",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  headline: "hero-headline",
  subheadline: "hero-subheadline",
  ctaWork: "hero-cta-view-work",
  ctaContact: "hero-cta-contact",
};

export const PROJECTS = {
  section: "featured-projects-section",
  card: (slug) => `project-card-${slug}`,
  liveDemo: (slug) => `project-${slug}-view-live-demo`,
  requestSimilar: (slug) => `project-${slug}-request-similar`,
  badgeStatus: (slug) => `project-${slug}-status-badge`,
};

export const ABOUT = {
  section: "about-section",
  portrait: "about-portrait",
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputProjectType: "contact-input-project-type",
  inputMessage: "contact-input-message",
  submit: "contact-submit-button",
  success: "contact-success-message",
};

export const FOOTER = {
  root: "site-footer",
  email: "footer-email",
};
